import React, { useEffect, useState } from 'react';
import ProgressLoader from 'components/Loader/ProgressLoader';

export const DelayedLoader = () => {
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return showLoader ? <ProgressLoader /> : null;
};

export default DelayedLoader;
